import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10b4cee7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "footer",
  class: "section-wrap"
}
const _hoisted_2 = { class: "section customize-section" }
const _hoisted_3 = { class: "left-side" }
const _hoisted_4 = { class: "column-loc" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title column-title" }, " Extras ", -1))
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "column-loc" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title column-title" }, " Resources ", -1))
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "column-loc" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title column-title" }, " Community ", -1))
const _hoisted_17 = ["href"]
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href"]
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "footer__socials-and-subscribe-email" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "launch-btn" }, null, -1))

import FooterSocials from './FooterSocials.vue'
import { linkTo } from '@/constants'

export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

// import SubscribeEmail from '@/components/Content/SubscribeEmail.vue'

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("a", {
            href: _unref(linkTo).pwnSafe,
            target: "_blank",
            class: "footer-link local-link"
          }, "PWN Safe", 8, _hoisted_6),
          _createElementVNode("a", {
            href: _unref(linkTo).cryptonativeReport,
            target: "_blank",
            class: "footer-link local-link"
          }, "Cryptonative report", 8, _hoisted_7),
          _createElementVNode("a", {
            href: _unref(linkTo).blog,
            target: "_blank",
            class: "footer-link local-link"
          }, "Blog", 8, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("a", {
            href: _unref(linkTo).docs,
            target: "_blank",
            class: "footer-link local-link"
          }, "Docs", 8, _hoisted_11),
          _createElementVNode("a", {
            href: _unref(linkTo).github,
            target: "_blank",
            class: "footer-link local-link"
          }, "Github", 8, _hoisted_12),
          _createElementVNode("a", {
            href: _unref(linkTo).audit,
            target: "_blank",
            class: "footer-link local-link"
          }, "Audits", 8, _hoisted_13),
          _createElementVNode("a", {
            href: _unref(linkTo).faq,
            target: "_blank",
            class: "footer-link local-link"
          }, "FAQ", 8, _hoisted_14)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("a", {
            class: "footer-link local-link",
            href: _unref(linkTo).email
          }, " Email us ", 8, _hoisted_17),
          (_unref(linkTo).telegram)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _unref(linkTo).telegram,
                target: "_blank",
                class: "footer-link local-link"
              }, "Telegram", 8, _hoisted_18))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            href: _unref(linkTo).discord,
            target: "_blank",
            class: "footer-link local-link"
          }, "Discord", 8, _hoisted_19),
          _createElementVNode("a", {
            href: _unref(linkTo).careers,
            target: "_blank",
            class: "footer-link local-link"
          }, "Careers", 8, _hoisted_20)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(FooterSocials)
        ])
      ])
    ]),
    _hoisted_22
  ]))
}
}

})